var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 45,
    viewBox: "0 0 28 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25.6665,
    width: 2,
    height: 18.6667,
    rx: 1,
    fill: "#507278"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#587E85",
    stroke: "#507278",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1565_264911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 22.1456C13.0048 22.1456 12.0487 21.967 11.1647 21.6401L11.1647 16.8096C11.1647 13.7238 13.6469 11.2165 16.7278 11.1666L16.8213 11.1659L21.6628 11.1658C21.9904 12.0478 22.1694 13.0018 22.1694 13.9975C22.1694 14.9858 21.9931 15.9331 21.67 16.8096L16.8213 16.8096L16.8213 21.6473C15.9428 21.9697 14.9934 22.1456 14.0028 22.1456Z",
    fill: "#9EC237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4199 11.1654L17.4191 11.2591C17.369 14.3436 14.8472 16.8287 11.7437 16.8287H11.1646L11.1841 11.1849L17.4199 11.1654Z",
    fill: "#749024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 5.83228C15.0006 5.83228 15.9567 6.01087 16.8407 6.33777L16.8407 11.1683C16.8407 14.2541 14.3585 16.7615 11.2776 16.8113L11.1841 16.812L6.34259 16.8121C6.01494 15.9301 5.83594 14.9761 5.83594 13.9804C5.83594 12.9921 6.01231 12.0448 6.33537 11.1683L11.1841 11.1683L11.1841 6.33057C12.0626 6.00825 13.012 5.83228 14.0026 5.83228Z",
    fill: "url(#paint0_linear_1565_264911)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_264911",
    x1: 7.37963,
    y1: 7.41535,
    x2: 14.9599,
    y2: 14.0752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0EC45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9CF3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1565_264911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3333,
    height: 16.3333,
    fill: "white",
    transform: "translate(5.8335 5.83337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.87a96296ec62618d4a656195f1096dc9.svg";
export { ForwardRef as ReactComponent };